(function () {

    if (document.querySelector(".announcement-bar .close_icon")) {
        const announcementBarClose = document.querySelector(".announcement-bar .close_icon");
        announcementBarClose.addEventListener("click", function (e) {
            this.closest(".announcement-bar").style.display = "none";
        });
    }


    let subMenuTitles = document.querySelectorAll(".js-show-sub-menu");
    // console.log(subMenuTitles)
    if (subMenuTitles.length) {
        subMenuTitles.forEach((subMenuTitle) => {
            subMenuTitle.addEventListener("click", _handleSubmenuClick.bind(this));
            // megaMenuTitle.addEventListener("mouseleave", _handleMegaMenuHover.bind(this));
        });

    }

    function _handleSubmenuClick({ currentTarget }) {
        let selectedTitle = currentTarget.querySelector("a").getAttribute("data-title");


        if (currentTarget.classList.contains("menu-active")) {
            currentTarget.closest(".navigation__item--with-mega-menu").querySelectorAll(".js-show-sub-menu").forEach((subMegaMenu) => subMegaMenu.classList.remove("menu-active"));
            document.querySelectorAll(`.menu-promotion__image`).forEach((element) => element.classList.add("js-hidden"));
            document.querySelectorAll(`.menu-promotion__image[data-title="${selectedTitle}"]`).forEach((element) => element.classList.remove("js-hidden"));
        } else {
            currentTarget.closest(".navigation__item--with-mega-menu").querySelectorAll(".js-show-sub-menu").forEach((subMegaMenu) => subMegaMenu.classList.remove("menu-active"));
            currentTarget.classList.add("menu-active");
            currentTarget.closest(".navigation__item--with-mega-menu").querySelectorAll(`.menu-promotion__image`).forEach((element) => element.classList.add("js-hidden"));
            document.querySelectorAll(`.menu-promotion__image[data-title="${selectedTitle}"]`).forEach((element) => element.classList.remove("js-hidden"));
        }


        // if (event.currentTarget.classList.contains("js-show-sub-menu")) {
        //     title = event.currentTarget.querySelector(".js-mega-menu-sub-heading").getAttribute("data-title");
        //     console.log(title,event.currentTarget)
        //     document.querySelectorAll(".js-show-sub-menu").forEach((subMegaMenu) => subMegaMenu.classList.remove("menu-active"));
        // event.currentTarget.classList.add("menu-active");
        // }
        // document.querySelectorAll(`.menu-promotion__image`).forEach((element) => {
        //     // let imageTitle = element.getAttribute("data-title");
        //     // console.log(imageTitle)
        //     // if(imageTitle === title){

        //     //     element.classList.remove("js-hidden");
        //     // }
        //     element.classList.add("js-hidden");
        //     element.querySelector(`.menu-promotion__image[data-title="${title}"]`) ? element.querySelector(`.menu-promotion__image[data-title="${title}"]`).classList.toggle("js-hidden") : null;
        // });

    }
    if (document.querySelector(".js-add-to-cart-sticky-button")) {
        let stickAddToCartButton = document.querySelector(".js-add-to-cart-sticky-button");
        stickAddToCartButton.addEventListener("click", _scrollToProductVariant.bind());

        function _scrollToProductVariant() {
            if (window.scrollY > 700) {
                let scrollToElement = document.querySelector(".product-form");
                //scrollToElement.scrollIntoView({behavior: 'smooth'})
                $('html, body').animate({
                    scrollTop: $(scrollToElement).offset().top
                }, 750);
            }
        }
    }


    /**
     * 
     * Custom Swatch Click PdP
     * 
     */
    if (document.querySelectorAll(".js-custom_options").length) {
        let optionElement = document.querySelectorAll(".js-custom_options");
        optionElement.forEach(function (event) {
            event.addEventListener("click", _customOptionsSelect.bind(this))
        });

        function _customOptionsSelect(option) {
            let optionValue = option.currentTarget.getAttribute('value');
            let dropDownOption = option.currentTarget.closest(".option-selectors").querySelector(".js-hidden").querySelectorAll(".js-option");
            dropDownOption.forEach(function (e) {
                let dropdownOptionsValue = e.getAttribute("data-value");
                if (optionValue === dropdownOptionsValue) {
                    e.setAttribute("aria-selected", "true");
                    let buttonSelector = option.currentTarget.closest(".option-selectors").querySelector(".js-hidden").querySelectorAll(".cc-select__btn");
                    buttonSelector.innerHtml = dropdownOptionsValue;

                } else {
                    e.setAttribute("aria-selected", "false");
                }
            })
        }

    }

    /**
     * 
     * Sticky bar hide and show event
     * 
     */
    let stickyBarPdp = document.querySelector(".js--sticky-wrapper");
    if (stickyBarPdp) {
        window.addEventListener("scroll", function (e) {
            let mainProductTopHeight = (document.querySelector(".container .buy-buttons-row").offsetTop + document.querySelector(".container .buy-buttons-row").offsetHeight) + (document.querySelector("#shopify-section-header").offsetHeight + document.querySelector("#shopify-section-header").offsetTop) + (document.querySelector("#shopify-section-announcement-bar").offsetHeight);

            if ($(document).find(".section-special-product-banner").length) {
                if (window.innerWidth > 767) {
                    mainProductTopHeight = (document.querySelector(".section-special-product-banner").offsetHeight) - (document.querySelector("#shopify-section-header").offsetHeight - document.querySelector("#shopify-section-announcement-bar").offsetHeight + 200);
                } else {
                    mainProductTopHeight = (document.querySelector(".section-special-product-banner").offsetHeight) - (document.querySelector("#shopify-section-header").offsetHeight - document.querySelector("#shopify-section-announcement-bar").offsetHeight + 100);
                }
            } else {
                mainProductTopHeight = (document.querySelector(".container .buy-buttons-row").offsetTop + document.querySelector(".container .buy-buttons-row").offsetHeight);
            }
            if (window.pageYOffset >= mainProductTopHeight) {
                stickyBarPdp.classList.add("is-sticky");
            } else {
                stickyBarPdp.classList.remove("is-sticky");
            }

        });
    }
    /**
     * 
     * Custom Zoom on PdP
     * 
     */

    if (document.querySelectorAll(".product-zoom-images").length) {
        let zoomImagesArray = document.querySelectorAll(".product-zoom-images");

        function _handleZoomIn({ currentTarget }) {
            let imageId = currentTarget.getAttribute("id");
            document.querySelectorAll(".img-magnifier-glass").forEach((magnifyElement) => magnifyElement.remove());
            window.magnify(imageId, 2);
        }

        zoomImagesArray.forEach((zoomImage) => {
            zoomImage.addEventListener("mouseover", _handleZoomIn.bind(this), true);
        });
    }

    /**
   * 
   * Active tab when click on footer link
   * 
   */

    let footerLinkElements = document.querySelectorAll(".js-footer-link");
    footerLinkElements.forEach(function (footerLinkElement) {
        footerLinkElement.addEventListener("click", _legalPageTabActivation.bind(this));
    });

    function _legalPageTabActivation(event) {
        let footerLinkAttribute = event.currentTarget.getAttribute('data-title');
        localStorage.setItem("footerLink", footerLinkAttribute);
    }

    let tabLinkElements = document.querySelectorAll(".js-tab-link-active");
    if (document.querySelectorAll(".js-tab-link-active")) {
        tabLinkElements.forEach(function (tabLinkElement) {
            let tabLinkAttribute = tabLinkElement.getAttribute("data-tab");
            let footerClickedLinkItem = localStorage.getItem("footerLink");
            if (tabLinkAttribute == footerClickedLinkItem) {
                tabLinkElement.click();
            }
        });
    }

})();
